(function(){
  var $body = document.querySelector('body');
  var $header = document.querySelector('.js-header');
  if ($header) {

    // Toggle dropdown
    var $dropdownToggler = $header.querySelector('.js-dropdown-toggler');
    if ($dropdownToggler) {
      var $dropdown = $header.querySelector('.js-dropdown');

      $dropdownToggler.addEventListener('click', function () {
        $body.classList.toggle('is-overlaid-mobile');
        $dropdownToggler.classList.toggle('is-opened');
        $dropdown.classList.toggle('is-opened');
      });
    }

    // Shrink header
    var headerHeight = $header.offsetHeight;
    window.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        $header.classList.toggle('is-shrinked', (window.scrollY >= headerHeight));
      });
    });
  }
})();
